import gql from 'graphql-tag'

export const CURRENT_METRIC = gql`
  query getCurrentMetrics($sensor_ids: [String!], $occurred_at: timestamp) {
    latest_metrics(
      where: {
        sensor: { _in: $sensor_ids }
        occurred_at: { _gte: $occurred_at }
      }
    ) {
      sensor
      value
      received_at
      occurred_at
      metadata
    }
  }
`

export const CURRENT_METRIC_UPDATED = gql`
  subscription getCurrentMetricsUpdated(
    $sensor_ids: [String!]
    $occurred_at: timestamp
  ) {
    latest_metrics(
      where: {
        sensor: { _in: $sensor_ids }
        occurred_at: { _gte: $occurred_at }
      }
    ) {
      sensor
      value
      received_at
      occurred_at
      metadata
    }
  }
`

// export const LATEST_METRIC = gql`
// query getCurrentMetrics($sensor_ids: [String!]){
//   latest_metrics(where: {
//       sensor: {_in: $sensor_ids}
//     }) {
//     sensor
//     value
//     received_at
//     occurred_at
//     metadata
//   }
// }
// `

export const LATEST_METRIC_UPDATED = gql`
  subscription getCurrentMetricsUpdated($sensor_ids: [String!]) {
    latest_metrics(where: { sensor: { _in: $sensor_ids } }) {
      sensor
      value
      received_at
      occurred_at
      metadata
    }
  }
`

export const SORT_METRIC_REGISTRATION = gql`
  query getCurrentMetricsRegistration($occurred_at: timestamp) {
    sort_metrics_aggregate(where: { occurred_at: { _gt: $occurred_at } }) {
      aggregate {
        count(columns: id)
      }
    }
  }
`

export const SORT_METRIC_PER_PAGE = gql`
  query getCurrentMetricsPerPage(
    $occurred_at: timestamp
    $limit: Int
    $offset: Int
  ) {
    sort_metrics(
      where: { occurred_at: { _gt: $occurred_at } }
      limit: $limit
      offset: $offset
    ) {
      sensor
      value
      received_at
      occurred_at
      metadata
    }
  }
`

export const SORT_CURRENT_METRIC_PER_PAGE_UPDATED = gql`
  subscription getCurrentMetricsPerPageUpdated(
    $occurred_at: timestamp
    $limit: Int
    $offset: Int
  ) {
    sort_metrics(
      where: { occurred_at: { _gt: $occurred_at } }
      limit: $limit
      offset: $offset
    ) {
      sensor
      value
      received_at
      occurred_at
      metadata
    }
  }
`

export const SORT_METRIC_BY_VEHICLE = gql`
  query getSortMetricsByVehicle($jsonFilter: jsonb) {
    latest_metrics(
      limit: 1
      where: { metadata: { _contains: $jsonFilter } }
      order_by: { occurred_at: desc }
    ) {
      value
      occurred_at
      metadata
    }
  }
`

export const SORT_METRIC_BY_VEHICLE_UPDATED = gql`
  subscription getSortMetricsByVehicleUpdated($jsonFilter: jsonb) {
    latest_metrics(
      limit: 1
      where: { metadata: { _contains: $jsonFilter } }
      order_by: { occurred_at: desc }
    ) {
      value
      occurred_at
      metadata
    }
  }
`

export const SEARCH_METRICS = gql`
  query getSearchMetrics(
    $sensor_ids: [String!]
    $occurred_at: timestamp
    $search: String!
  ) {
    latest_metrics(
      where: {
        sensor: { _in: $sensor_ids }
        occurred_at: { _gte: $occurred_at }
        plate_number: { _ilike: $search }
      }
    ) {
      metadata
      sensor
      occurred_at
      received_at
      value
    }
  }
`

export const SEARCH_IN_LATEST_METRICS = gql`
  query getSearchMetrics($sensor_ids: [String!], $search: String!) {
    latest_metrics(
      where: { sensor: { _in: $sensor_ids }, plate_number: { _ilike: $search } }
    ) {
      metadata
      sensor
      occurred_at
      received_at
      value
    }
  }
`

export const SEARCH_METRICS_UPDATED = gql`
  subscription getSearchMetricsUpdated(
    $sensor_ids: [String!]
    $search: String!
  ) {
    latest_metrics(
      where: { sensor: { _in: $sensor_ids }, plate_number: { _ilike: $search } }
    ) {
      metadata
      sensor
      occurred_at
      received_at
      value
    }
  }
`

export const STATE_OF_CURRENT_DAY_BY_VEHICLE = gql`
  query Metric($occurred_at: timestamp, $jsonFilter: jsonb) {
    metrics(
      where: {
        occurred_at: { _gte: $occurred_at }
        metadata: { _contains: $jsonFilter }
      }
      order_by: { occurred_at: desc }
    ) {
      occurred_at
      value
    }
  }
`

export const STATE_OF_SELECTED_DAY_BY_VEHICLE = gql`
  query Metric($start: timestamp, $end: timestamp, $sensor: String!) {
    metrics(
      where: {
        occurred_at: { _gte: $start, _lte: $end }
        sensor: { _eq: $sensor }
      }
      order_by: { occurred_at: desc }
    ) {
      occurred_at
      value
    }
  }
`

export const STATE_CREATED_OF_CURRENT_DAY_BY_VEHICLE = gql`
  subscription ($occurred_at: timestamp, $sensor: String!) {
    metrics(
      limit: 1
      where: { occurred_at: { _gte: $occurred_at }, sensor: { _eq: $sensor } }
      order_by: { occurred_at: desc }
    ) {
      occurred_at
      value
    }
  }
`

export const STATE_OF_SELECTED_MONTH_BY_VEHICLE = gql`
  query getDateWithValueBySensor(
    $sensor: String!
    $startMonth: date
    $endMonth: date
  ) {
    dates_with_value_by_sensor(
      where: {
        sensor: { _eq: $sensor }
        date: { _gte: $startMonth, _lte: $endMonth }
      }
    ) {
      date
    }
  }
`

export const FIRST_METRIC_OF_DAY = gql`
  query ($occurred_at: timestamp, $jsonFilter: jsonb) {
    metrics(
      where: {
        occurred_at: { _gte: $occurred_at }
        metadata: { _contains: $jsonFilter }
      }
      order_by: { occurred_at: asc }
      limit: 1
    ) {
      value
      occurred_at
      metadata
    }
  }
`

export const LATEST_METRIC = gql`
  query ($trackable_labels: [String!]!) {
    latest_metrics(trackable_labels: $trackable_labels) {
      value
      occurred_at
      received_at
      trackable_label
      metadata
      registration_number
    }
  }
`

export const METRICS_BY_DATE = gql`
  query ($trackable_label: String!, $date: Date!) {
    metrics_by_date(trackable_label: $trackable_label, date: $date) {
      value
      occurred_at
      received_at
      trackable_label
      metadata
      registration_number
    }
  }
`

export const METRICS_EVENT_DATE = gql`
  query ($trackable_label: String!) {
    metrics_date_month(trackable_label: $trackable_label) {
      date
      trackable_label
    }
  }
`
